import { inject } from 'vue'

export function useRogueBuilder(): any {
  const rogueBuilder = inject<boolean>('ROGUE_BUILDER', false)
  if (!rogueBuilder) {
    return false
  }

  return true
}